import React, { useState } from "react";
import { useAuth } from "../auth/AuthContext";
import { getRecaptchaToken } from "../lib/recaptcha";

export const ForgotPasswordPage: React.FC = () => {
  const { client } = useAuth();
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "sent" | "error">("idle");

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setStatus("idle");
    const recaptchaToken = await getRecaptchaToken("forgot_password");
    const response = await client.post("/auth/forgot-password", {
      email,
      recaptchaToken,
    });
    setStatus(response.ok ? "sent" : "error");
  };

  return (
    <div className="container py-5" style={{ maxWidth: 520 }}>
      <h1 className="mb-3">Esqueci a senha</h1>
      <p className="text-muted">
        Informe seu email. Se existir, enviaremos um link para redefinir a senha.
      </p>
      <form onSubmit={handleSubmit} className="d-grid gap-3">
        <div>
          <label className="form-label">Email</label>
          <input
            className="form-control"
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
          />
        </div>
        {status === "error" && (
          <div className="alert alert-danger">
            Nao foi possivel enviar. Tente novamente.
          </div>
        )}
        {status === "sent" && (
          <div className="alert alert-success">
            Se o email existir, voce recebera o link em instantes.
          </div>
        )}
        <button className="btn btn-primary" type="submit">
          Enviar link
        </button>
      </form>
    </div>
  );
};
